import assigneesService from '@/services/assignees';
import assigneesDB from "@mobile/db/assignees";

export default {
    resetAll({ commit }) {
        commit('authentication/reset');
        commit('checklists/reset');
        commit('inspections/reset');
        commit('drafts/reset');
        commit('todos/reset');
        commit('conduct/reset');
        commit('connection/reset');
        commit('sync/reset');
        commit('notifications/reset');
        commit('issues/reset');
    },

    async applicationConnected({ commit }) {
        try {
            const assignees = await assigneesService.all();
            commit('assigneesRetrieved', assignees)
        } catch (error) {
            const assignees = await assigneesDB.first();
            commit('assigneesOfflineRetrieved', assignees)
        }
    },
};
